// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".episode {\n    color: white;\n    text-align: left;\n    display: flex;\n    margin-bottom: 1rem;\n}\n\n.episode > iframe {\n    object-fit: contain;\n    align-self: flex-start;\n    padding: 10px 10px 0 0;\n}\n\n.episode-details {\n    flex: 1 1 auto;\n}\n\n.episode-title {\n    margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
